// Common
export const VIEW_END_LOADING = "viewEndLoading";
export const VIEW_START_LOADING = "viewSearchLoading";

// Interface
export const CONTENT_LOAD_I18N_STRINGS = "contentLoadI18NStrings";
export const CONTENT_LOAD_VOCABULARY_FORMATS = "contentLoadVocabualryFormats";
export const CONTENT_LOAD_VOCABULARY_LANGUAGES = "contentLoadVocabualryLanguages";

// Search
export const SEARCH = "search";
export const SEARCH_QUERY_CHANGED = "searchQueryChanged";
export const SEARCH_FACETS_CHANGED = "searchFacetsChanged";
export const SEARCH_PAGE_NEXT = "searchPageNext";
export const SEARCH_PAGE_PREV = "searchPagePrevious";
